export default __webpack_public_path__ + "static/media/1_0094.f8792263.webp";